import React from 'react'
import Link from 'gatsby-link'

const Menu = (props) => (
    <nav id="menu">
        <div className="inner">
            <ul className="links">
                <li><Link onClick={props.onToggleMenu} to="/">Home</Link></li>
                <li><Link onClick={props.onToggleMenu} to="/group">Grupo AH Business</Link></li>
                <li><Link onClick={props.onToggleMenu} to="/fields">Áreas de Negócio</Link></li>
                <li><Link onClick={props.onToggleMenu} to="/values">Nossos Valores</Link></li>
            </ul>
            <ul className="actions vertical">
                {/*<li><a href="#" className="button special fit">Ver mais</a></li>*/}
            </ul>
        </div>
        <a className="close" onClick={props.onToggleMenu} href="javascript:;">Close</a>
    </nav>
)

Menu.propTypes = {
    onToggleMenu: React.PropTypes.func
}

export default Menu



// WEBPACK FOOTER //
// ./src/components/Menu.js